import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import FallbackSpinnerLoader from '../components/FallbackSpinnerLoader';

import BusinessSidebar from '../partials/business/BusinessSidebar';
import Sidebar from '../partials/Sidebar';
import HomeEmptyState from '../components/HomeEmptyState';
const Dashboard = React.lazy(() => import('../pages/Dashboard'));
const ChatHome = React.lazy(() => import('../pages/ChatHome'));

import useBusinessStore from '../state/businessStore';

import './Layout.scss';

const Layout = () => {
  //:: Get businesses from Zustand store
  const { businesses, getUserRole } = useBusinessStore();

  const location = useLocation();

  // Home (/) shows the admin "Chat with your company" assistant; collaborators
  // (who can't use it) fall back to the Dashboard they saw before.
  const isCollaborator = getUserRole() === 'Collaborator';
  const HomeView = isCollaborator ? Dashboard : ChatHome;

  return (
    <div className="app">
      <BusinessSidebar />
      <Sidebar />
      <main className="content">
        {businesses.length === 0 ? (
          <HomeEmptyState />
        ) : location.pathname === '/' ? (
          <Suspense
            fallback={
              <>
                <div></div>
                <FallbackSpinnerLoader />
              </>
            }
          >
            <HomeView />
          </Suspense>
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
};

export default Layout;
